<template>
  <div id="dictionary">
    <form-dictionary
      :params="formParams"      
      :close-popups="closePopups"
      :pop-ups="popUps"
      :open-alert="openAlert"
      :submit-form="submitForm"
    ></form-dictionary>
    <table-view 
      :component-key="componentKey"
      :end-point="endPoint"
      :column-defs="columnDefs"
      :form-params="formParams"
      :pop-ups="popUps"
      :filters="filters"
      :buttons="buttons"
      :params="params"
      >
    </table-view>
  </div>
</template>

<script>
import axios from "@/axios.js"
import FormDictionary from '../../components/forms/Dictionary';
import TableView from '../../components/tableView';
export default {
  components: {
    FormDictionary,
    TableView
  },
  data() {
    let data = {
      componentKey: 0,
      popUps:{popupAddActive: false},
      params:{title:'',formType:'add'},
      formParams:{placeholder:'',value_en:'',value_ru:'',formType:'add'},
      lineDetails:{},
      filters:{disable:true},
      columnDefs: [
        {
          headerName: 'placeholder',
          field: 'placeholder',
          filter: true,
          width: 250,
        },
        {
          headerName: 'English',
          field: 'value_en',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Russian',
          field: 'value_ru',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Edit',
          field:'editDic',
          action: 'editDic',
          filter: false,
          cellStyle: {color: 'orange'},
          cellRenderer: function() {
            return 'Edit';
          }
        }
      ],
      endPoint:'dictionary',
      buttons:{
          addForm: true,
      },
    }
    return data;
  },
  computed: {
  },
  methods: {
    reLoadDictionary: function() {
      axios.get('/api/dictionary').then(function(result){
        let messages = {
          en:{},
          ru:{}
        }
        for(let i in result.data){
          messages.en[result.data[i].placeholder] = result.data[i].value_en;
          messages.ru[result.data[i].placeholder] = result.data[i].value_ru;
        }
        localStorage.setItem('dictionary', JSON.stringify(messages));
      });
    },
    submitForm: function(){
      let that = this;
      this.$validator.validateAll().then(result => {
        if(result) {
          if(that.formParams.formType=='add')
            that.sendData();
          else
            that.updateData();
        }
      })
    },
    translate: function(key){
      return this.$t(key);
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    sendData: function(){
      let that = this;
      this.$vs.loading();
      axios.post("/api/dictionary",this.formParams)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.success){
          that.closePopups();
          that.openAlert('success','Success');
          that.componentKey++;
        } else{
          that.openAlert('danger','Failed',data.messsage);
        }
        })
      .catch((error) => { console.log('error',error); that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    updateData: function(){
      let that = this;
      this.$vs.loading();
      axios.put("/api/dictionary",this.formParams)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.success){
          that.closePopups();
          that.openAlert('success','Success');
          that.componentKey++;
        } else{
          that.openAlert('danger','Failed',data.messsage);
        }
        })
      .catch((error) => { console.log('error',error); that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    closePopups: function(){
      this.componentKey++;
      this.popUps.popupAddActive = false;
      this.formParams = {formType:'add'};
      this.$forceUpdate();
    }
  },
  mounted() {

  }
}

</script>